export default {
	articleMaster: [
		"Item Description",
		"Item Code",
		"Item Type",
		"Department",
		"Category",
		"Sub Category",
		"Order Unit",
		"Contains Each(Base)",
		"Base Unit",
		"Primary Shelf life",
		"Secondary Shelf life",
		"Ordering Frequency",
		"Forecast Type",
		"Lead Time",
		"Service Level",
		"Current Cost",
		"Sales Price",
		"Product Remarks",
		"Stock Comes from",
		"Min Stock Level"
	],
	workforceArticalMaster: [
		"Item Code",
		"Item Description",
		"Item Type",
		"Department",
		"Category",
		"Sub Category",
		"Sales Price"
	],
	pastSales: [
		"Calendar Date",
		"Time",
		"Bill No",
		"Order Type",
		"Item Name",
		"Item Code",
		"Total Quantity",
		"Bill Amount"
	],
	Bom: [
		"Item Code",
		"Product Name / Menu",
		"Item Code (Ingredient)",
		"Item Name",
		"Quantity",
		"Base Unit"
	],
	setupUserAccounts: [
		"Country",
		"City",
		"Region",
		"Sub Region/Zone",
		"Store/Account Name",
		"Account Type",
		"Store Type",
		"Email",
		"Designation",
		"First Name",
		"Last Name",
		"Address",
		"Access",
		"Latitude",
		"Longitude",
		"Forecast-View",
		"Forecast-Edit",
		"Replenishment-View",
		"Replenishment-Edit",
		"Replenishment-Approve",
		"Expiry-View",
		"Expiry-Edit",
		"Inventory Management-View",
		"Inventory Management-Edit",
		"Inventory Management-Movement",
		"Inventory Management-Value",
		"Inventory Management-Sell",
		"Inventory Management-Approve"
	],
	stockCount: [
		"Item Name",
		"Item Code",
		"Batch Number",
		"Qty",
		"Loose",
		// "Date",
		// "Actual Pack Count",
		// "Actual Pack Count Qty",
		// "Actual Loose Count",
		// "Actual Loose Count Qty",
		"Contains Each(Base)",
		"Expiry Date",
		"Delivery Date",
		"Cost"
	],
	productCsv: [
		"Item Name",
		"Item Code",
		"Order Unit",
		"Contains",
		"Base Unit",
		"Order Unit Cost",
		"Weighable (Yes/No)",
		"Minimum Order(Order Unit)",
		"Deposit (If Any) Y/N",
		"Tax %",
		"ETA"
	]
};
